export default __webpack_public_path__ + "static/features-mega-image-3ebafabb93b7e4ebd398f07f93d1940e.png";